import React, { Component } from 'react';
import classNames from 'classnames';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = ".LyiPN,.glob_fontElementMap,.oopu6{font-family:var(--ricos-font-family,unset)}.LyiPN{color:#646464;display:flex;position:absolute}[dir] .LyiPN{background:#fff;border:1px solid #ddd;border-radius:6px;padding:12px 24px}[dir=ltr] .LyiPN{box-shadow:1px 1px 3px 1px #dcdcdc}[dir=rtl] .LyiPN{box-shadow:-1px 1px 3px 1px #dcdcdc}";
var styles = {"fontElementMap":"oopu6","panelContainer":"LyiPN"};
styleInject(css_248z);

class Panel extends Component {
  constructor(props) {
    super(props);
    this.stateFromProps = (componentState) => {
      const { keyName, boundingRect, isActive } = componentState.activeButton || {};
      if (keyName === this.props.keyName && boundingRect && isActive) {
        return {
          visible: true,
          style: {
            transition: "transform 0.15s cubic-bezier(.3,1.2,.2,1)"
          }
        };
      } else {
        return {
          visible: false,
          style: {
            transform: "translate(-50%) scale(0)"
          }
        };
      }
    };
    this.componentWillReceiveProps = (nextProps) => {
      this.setState(this.stateFromProps(nextProps.componentState));
    };
    this.render = () => {
      const Content = this.props.content;
      const modalClasses = classNames(styles.panelContainer, this.props.theme.panelContainer);
      return /* @__PURE__ */ React.createElement("div", { className: modalClasses, style: this.state.style }, /* @__PURE__ */ React.createElement(
        Content,
        {
          store: this.props.store,
          helpers: this.props.helpers,
          componentData: this.props.componentData,
          componentState: this.props.componentState,
          theme: this.props.theme,
          t: this.props.t,
          tabIndex: this.state.visible ? 0 : -1,
          getEditorBounds: this.props.getEditorBounds
        }
      ));
    };
    this.state = this.stateFromProps(props.componentState);
  }
}

export { Panel as default };
//# sourceMappingURL=Panel.js.map
